import { useCallback, useRef, useState } from 'react';
// Custom hook for pan/zoom functionality
export function usePanZoom(diagramSize, viewportRef) {
    const [scale, setScale] = useState(1);
    const [pan, setPan] = useState({
        x: 0,
        y: 0
    });
    const fitToScreen = useCallback(()=>{
        const vp = viewportRef.current;
        if (!vp || !diagramSize) return;
        const vpW = vp.clientWidth;
        const vpH = vp.clientHeight;
        const { width, height } = diagramSize;
        const k = Math.min(vpW / width, vpH / height) * 0.95;
        const offX = Math.max(0, (vpW - width * k) / 2);
        const offY = Math.max(0, (vpH - height * k) / 2);
        setScale(k);
        setPan({
            x: offX,
            y: offY
        });
    }, [
        diagramSize,
        viewportRef
    ]);
    const resetView = useCallback(()=>{
        setPan({
            x: 0,
            y: 0
        });
        setScale(1);
    }, []);
    return {
        scale,
        setScale,
        pan,
        setPan,
        fitToScreen,
        resetView
    };
}
// Custom hook for drag interactions
export function useDragPan(pan, setPan) {
    const draggingRef = useRef(null);
    const beginDrag = useCallback((e)=>{
        const el = e.currentTarget;
        draggingRef.current = {
            x: e.clientX,
            y: e.clientY,
            panX: pan.x,
            panY: pan.y
        };
        el.style.cursor = 'grabbing';
    }, [
        pan
    ]);
    const onDrag = useCallback((e)=>{
        if (!draggingRef.current) return;
        const dx = e.clientX - draggingRef.current.x;
        const dy = e.clientY - draggingRef.current.y;
        setPan({
            x: draggingRef.current.panX + dx,
            y: draggingRef.current.panY + dy
        });
    }, [
        setPan
    ]);
    const endDrag = useCallback((e)=>{
        e.currentTarget.style.cursor = 'grab';
        draggingRef.current = null;
    }, []);
    return {
        beginDrag,
        onDrag,
        endDrag
    };
}
